// TODO Find an approach to Firefox privacy policy
import { loadFacebookSdk, performFacebookIdentification } from "../facebookAuthentication";
import { services } from "../../../../constants";
import { cache } from "../../../persistence/cache";
import { socialProviders } from "../socialProviders";
import { canUpdateToken, updateUserData } from "../tokenOperations";
import { socialAuthenticationErrors } from "../facebookAuthentication/errors";

function getBackendSignupFunction(facebookResponse, config, resolve, reject) {
  return function doBackendSignup() {
    FB.api("/me", { fields: "email" }, async ({ email }) => {
      const { accessToken } = facebookResponse.authResponse;
      if (email === undefined) {
        reject({ error: socialAuthenticationErrors.EMAIL_PERMISSION_NOT_GRANTED, socialUserToken: accessToken });
        return;
      }
      starzSignup.call(this, resolve, reject, email, accessToken, config);
    });
  };
}

async function starzSignup(resolve, reject, username, socialUserToken, config) {
  try {
    const response = await this.http.post(`${this.backendHosts.auth}${services.signupV2}`, {
      username,
      socialProvider: socialProviders.FACEBOOK,
      socialUserToken,
      language: this.lang
    });
    // FIXME The following lines could be repeated somewhere else
    if (!!config.autologin && canUpdateToken(response)) {
      updateUserData.call(this, response.data.token, response.data.user.globalUserId, config);
      cache.clear({ database: "layouts" });
    }
    resolve(response.data);
  } catch (e) {
    const error = this.formatErrorObject(e);
    // FIXME The same way the SDK hides the JWT and other sensitive data, it should not expose socialUserToken. This impacts userManager.mergeAccounts()
    reject({ error, socialUserToken, username });
  }
}

const facebookSignup = {
  run(config) {
    return new Promise(async (resolve, reject) => {
      const { username, socialUserToken } = config;
      if (username && socialUserToken) {
        starzSignup.call(this, resolve, reject, username, socialUserToken, config);
      } else {
        loadFacebookSdk.call(
          this,
          this.identityProviders.facebook.libSrc,
          performFacebookIdentification.bind(this, config, resolve, reject, getBackendSignupFunction)
        );
      }
    });
  }
};

export default facebookSignup;
